//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.InspectionFeatureDataFilterBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../no/SelectFace.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CsysReferenceType",1,0],[1,"DataFilterBuilder",0,"CAM.InspectionFeatureDataFilterBuilder",0],[0,"EndType",1,0],[0,"InnerOuterType",1,0],[0,"Length",1,0],[0,"LengthDirVector",1,"Direction",0],[0,"LengthDirectionI",1,0],[0,"LengthDirectionJ",1,0],[0,"LengthDirectionK",1,0],[0,"LocationPointX",1,0],[0,"LocationPointY",1,0],[0,"LocationPointZ",1,0],[0,"Name",1,0],[0,"NormalDirectionI",1,0],[0,"NormalDirectionJ",1,0],[0,"NormalDirectionK",1,0],[1,"OffsetDistance",0,"CAM.InheritableDoubleBuilder",0],[0,"ReverseDirection",1,0],[1,"SelectProjectionFaces",0,"SelectFace",0],[1,"SelectedGeometry",0,"SelectNXObjectList",0],[0,"Width",1,0]],[[[],"UpdateParams",{},0,0],[[],"FlipNormal",{},0,0],[[],"UpdateOffset",{},0,0],[[],"ReverseOffsetDirection",{},0,0],[[],"UpdateEndType",{},0,0]],[]];
SPLM.CAM.InspectionCparlnFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionCparlnFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionCparlnFeatureBuilder.EndTypes = Object.freeze({
    "Round" : "Round", "Square" : "Square"});

export default SPLM;